const useCloudinary = (imgUrl, styles) => {
  // console.log(imgUrl);

  const imgUrlArray = imgUrl?.split('image/');
  const modifiedUrl = imgUrlArray?.length >= 1 && `${imgUrlArray[0]}upload/${styles}/${imgUrlArray[1]}`;
  return modifiedUrl;
};

export default useCloudinary;
